import { combineReducers } from 'redux';
import { firebaseStateReducer as firebase } from 'redux-react-firebase';

export default combineReducers({
  firebase,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js